import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { Checkbox, FormGroup, FormControlLabel, Box, Stack } from '@mui/material';

import RHFTextField from './RHFTextField';

// ----------------------------------------------------------------------

RHFCheckbox.propTypes = {
  name: PropTypes.string,
};

export function RHFCheckbox({ name, ...other }) {
  const { control } = useFormContext();

  return (
    <FormControlLabel
      control={
        <Controller
          name={name}
          control={control}
          render={({ field }) => <Checkbox {...field} checked={field.value} disabled={other.disabled} />}
        />
      }
      {...other}
    />
  );
}

// ----------------------------------------------------------------------

RHFMultiCheckbox.propTypes = {
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
};

export function RHFMultiCheckbox({ name, options, ...other }) {
  const { control } = useFormContext();

  const numCols = (optionsCount) => {
    let numCols = 1;
    if (optionsCount >= 8) {
      numCols = 2;
    }
    if (optionsCount >= 12) {
      numCols = 3;
    }
    return numCols;
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const onSelected = (option) =>
          field?.value.includes(option) ? field?.value.filter((value) => value !== option) : [...field?.value, option];

        return (
          <FormGroup>
            <Box
              sx={{
                display: 'grid',
                rowGap: 1,
                columnGap: 3,
                gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: `repeat(${numCols(options.length)}, 1fr)` },
              }}
            >
              {options.map((option) => (
                <>
                  <Stack
                    direction="row"
                    sx={{
                      mt: 1,
                      justifyContent: 'space-between',
                    }}
                  >
                    <FormControlLabel
                      key={option}
                      control={
                        <Stack>
                          <Checkbox
                            checked={field?.value !== undefined && field?.value.includes(option)}
                            onChange={() => field?.onChange(onSelected(option))}
                          />
                        </Stack>
                      }
                      label={option}
                      {...other}
                    />

                    {other.withTextField && (
                      <RHFTextField
                        name={option}
                        label={`Advance Payment Amount | ${option}`}
                        sx={{ width: '80%' }}
                        disabled={field?.value === undefined || !field?.value.includes(option)}
                      />
                    )}
                  </Stack>
                </>
              ))}
            </Box>
          </FormGroup>
        );
      }}
    />
  );
}
